<template>
  <div>
    <a-row v-for="item in items" :gutter="4" :style="{margin:'12px'}">
      <a-col :span="20">
        <a-input v-model:value="item.name" :placeholder="placeholder"/>
      </a-col>
      <a-col :span="4">
        <a-button type="link" @click="removeItem(item)">删除</a-button>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="24">
        <a-button type="link" icon="download" @click="addItem">
          {{addLabel}}
        </a-button>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import mixin from '../mixin/AExtArrayMixin'
export default {
    name: "index",
    mixins:[mixin],
    props: {
        addLabel: {
            type: String,
            //TODO: 修改
            default: '添加非专家库组员'
        },
        placeholder: {
            type: String,
            //TODO: 修改
            default: '请填写非专家库组员姓名'
        }
    },
    data() {
        return {
            localValue: '',
            items:[]
        }
    },
    watch:{
        items:{
            deep: true,
            immediate: true,
            handler: function (newValue) {
                let names=[];
                newValue.forEach(item=>{
                    names.push(item.name);
                });
                this.localValue=names.join(',');
            }
        }
    },
    created(){
        this.init()
    },
    methods:{
        init(){
            if(this.localValue){
                let names=this.localValue.split(",");
                let items=[];
                names.forEach(item=>{
                    items.push([{name:item}])
                });
                this.items=items;
            }
            else {
                this.items=[];
            }
        },
        addItem()
        {
            this.items.push({name:''});
        },
        removeItem(item)
        {
            this.items.remove(item);
        }
    }

}
</script>

<style scoped>

</style>